import React from "react";

import "./style.css";
import { ContactIconSummary } from "../../icons/ContactIcon/ContactIconSummary";
import { Col, Row } from "react-bootstrap";

export const ContactIconTextSummary = () => {
  return (
    // <div className="kontaktna-oseba-icon">
    <Row className="g-5">
      <Col xs={2} md={2} lg={2}>
        <ContactIconSummary />
      </Col>
      <Col className="d-flex align-items-center ps-4">
        <div className="text-wrapper">KONTAKTNA OSEBA</div>
      </Col>
    </Row>
  );
};